import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import {Auth0Provider} from '@auth0/auth0-react';

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const apiAudience = process.env.REACT_APP_API_AUDIENCE;

if (!auth0Domain || !auth0ClientId || !apiAudience) {
    throw new Error('Missing required Auth0 environment variables');
}


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Auth0Provider
            domain={auth0Domain}
            clientId={auth0ClientId}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/auth/callback`, // callback route
                audience: apiAudience, // Specify the API audience
                scope: "openid profile email offline_access" // Request specific scopes (what you want to receive)
            }}
            useRefreshTokens={true} // Keeps the user logged in on page refresh
            cacheLocation={"localstorage"} // Persists the session in the browser
            onRedirectCallback={(appState) => {
                window.history.replaceState(
                    {},
                    document.title,
                    appState?.returnTo || window.location.pathname
                );
            }}
        >
            <App/>
        </Auth0Provider>
    </React.StrictMode>
);